module.exports = {
  publicPath: '/',
  // productionSourceMap: false,
  devServer: {
    port: '8000',
    proxy: {      
      '^/(ktdp|test-api)': {
        target: 'http://localhost:8080',
        changeOrigin: true
      },
      '^/(signer|api|uploads)': {
        target: 'http://localhost:8002',
        changeOrigin: true
      },
      '^/(captcha)': {
        target: 'https://medp-dev.apwisdom.com/',
        changeOrigin: true
      }
    }
  }
}